var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8207 5.4001C17.8207 5.4001 17.6449 4.15908 17.1035 3.61416C16.418 2.89697 15.6516 2.89346 15.3 2.85127C12.7828 2.66846 9.00352 2.66846 9.00352 2.66846H8.99648C8.99648 2.66846 5.21719 2.66846 2.7 2.85127C2.34844 2.89346 1.58203 2.89697 0.896484 3.61416C0.355078 4.15908 0.182812 5.4001 0.182812 5.4001C0.182812 5.4001 0 6.85908 0 8.31455V9.67861C0 11.1341 0.179297 12.5931 0.179297 12.5931C0.179297 12.5931 0.355078 13.8341 0.892969 14.379C1.57852 15.0962 2.47852 15.0716 2.8793 15.1489C4.3207 15.286 9 15.3282 9 15.3282C9 15.3282 12.7828 15.3212 15.3 15.1419C15.6516 15.0997 16.418 15.0962 17.1035 14.379C17.6449 13.8341 17.8207 12.5931 17.8207 12.5931C17.8207 12.5931 18 11.1376 18 9.67861V8.31455C18 6.85908 17.8207 5.4001 17.8207 5.4001ZM7.14023 11.3345V6.27549L12.0023 8.81377L7.14023 11.3345Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.d5f24a523b960f8b670516e8eaf8c5d5.svg";
export { ForwardRef as ReactComponent };